Auth = require 'app/scripts/db/auth'
Promise = require 'bluebird'
xtend = require 'xtend'
$ = require "jquery"
{ slackTrelloDomain } = require '@trello/config'

slackKey = "7737388dfc54ea015104894e3a0a56f9"
token = ""

createPromise = (opts) ->
  new Promise (resolve, reject) ->
    opts = xtend opts,
      success: (args...) ->
        resolve(args)
        return
      error: (args...) ->
        reject(args)
        return
    $.ajax opts
    return

module.exports.ajaxTrello = (opts) ->
  opts.url = slackTrelloDomain + opts.url

  opts.data ?= {}
  opts.data.cookie = document.cookie
  createPromise(opts)
